import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import styles from './loading-journey.module.css';

/**
 * The ONE loading visual for the whole evidence journey — an animated
 * gradient progress bar with a stage label. Every wait state renders this
 * same component with a different stage/progress, so a reload reads as one
 * continuous journey instead of three unrelated spinners:
 *
 *   host mint  → "Preparing your evidence…"      (~0.15)
 *   pack open  → "Opening evidence pack…"        (~0.45)
 *   hydration  → "Reading failure analysis…"     (~0.85)
 *
 * Progress is deliberately pseudo (staged targets, not bytes): the bar
 * mounts slightly behind its target and eases forward, then creeps — the
 * "always moving" feel without lying about completion.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function LoadingJourney(_ref) {
  var _styles$variant;
  var stage = _ref.stage,
    progress = _ref.progress,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'bare' : _ref$variant;
  var target = Math.min(Math.max(progress, 0.05), 0.98);
  var _useState = useState(Math.max(target - 0.2, 0.03)),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  useEffect(function () {
    // Ease to the stage target on mount, then creep so it never stalls.
    var toTarget = requestAnimationFrame(function () {
      return requestAnimationFrame(function () {
        return setWidth(target);
      });
    });
    var creep = setInterval(function () {
      setWidth(function (w) {
        return Math.min(w + 0.015, target + 0.08 > 0.98 ? 0.98 : target + 0.08);
      });
    }, 1200);
    return function () {
      cancelAnimationFrame(toTarget);
      clearInterval(creep);
    };
  }, [target]);
  return /*#__PURE__*/_jsxs("div", {
    className: "".concat(styles.wrap, " ").concat((_styles$variant = styles[variant]) !== null && _styles$variant !== void 0 ? _styles$variant : ''),
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": Math.round(width * 100),
    "aria-label": stage,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.track,
      children: /*#__PURE__*/_jsx("span", {
        className: styles.fill,
        style: {
          width: "".concat(width * 100, "%")
        }
      })
    }), /*#__PURE__*/_jsx("span", {
      className: styles.stage,
      children: stage
    }, stage)]
  });
}